import type {
  IOrder,
  IOrderConfirmation,
  IOrderPayload,
} from "@commonTypes/order"
import type { IOffer } from "@commonTypes/offer"
import { baseServiceRequest } from "../baseServiceRequest"
import type {
  IFailedOrders,
  IUpdateOrderStatusRequest,
  ISaveOrderRequest,
} from "./types"

export const getFailedOrders = async (): Promise<IFailedOrders[]> => {
  const response = await baseServiceRequest({
    method: "GET",
    url: "/orders/exceptions",
  })
  return response.data
}

export const getOrderDetail = async (order_id: number): Promise<IOrder> => {
  const response = await baseServiceRequest({
    method: "GET",
    url: `/orders/order/${order_id}`,
  })
  return response.data
}

export const getAlternateOffers = async (
  order_id: number,
): Promise<IOffer[]> => {
  const response = await baseServiceRequest({
    method: "GET",
    url: `/orders/order/${order_id}/alternate_offers`,
  })
  return response.data
}

export const saveOrder = async (data: ISaveOrderRequest) => {
  const { body } = data

  return baseServiceRequest({
    method: "POST",
    url: `/orders/order`,
    data: { ...body, conversion_medium: "INSPIRE_CRM" },
  })
}

export const createOrder = async (
  data: Partial<IOrderPayload>,
): Promise<IOrder> => {
  const response = await baseServiceRequest({
    method: "POST",
    url: `/orders/order`,
    data,
  })
  return response.data
}

export const getOrderConfirmation = async (
  order_id: number,
): Promise<IOrderConfirmation> => {
  const response = await baseServiceRequest({
    method: "GET",
    url: `/orders/confirmation/${order_id}`,
  })
  return response.data
}

export const updateOrderStatus = async (data: IUpdateOrderStatusRequest) => {
  const { order_id, body } = data

  return baseServiceRequest({
    method: "POST",
    url: `/orders/order/${order_id}/status`,
    data: body,
  })
}
